import { Box, Divider, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import { useTranslation } from "react-i18next";

import AssignSkillForm from "./assign-skill-form";

interface AddWorkerSkillDialogProps {
	isOpen: boolean;
	onClose: () => void;
	onCombinedResult?: (result: { message: React.ReactNode; severity: "success" | "error" | "info" }) => void;
}

const AddWorkerSkillDialog: React.FC<AddWorkerSkillDialogProps> = ({
	isOpen,
	onClose,
	onCombinedResult,
}) => {
	const { t } = useTranslation();
	// const [{workerAssignedSkills, skillsMappedWithJob}] = useAddSkillDialog(onClose);
	return (
		<Dialog
			onClose={(e, reason) => {
				if (reason === "backdropClick") {
					return;
				}
				onClose();
			}}
			aria-labelledby='add-edit-certification'
			open={!!isOpen}
			maxWidth={false}
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<DialogTitle
				id='location-dialog-title'
				sx={{
					width: "900px",
					padding: "45px 45px 24px 45px",
				}}
			>
				<Typography
					sx={{
						fontFamily: "Roboto",
						fontSize: "20px",
						fontWeight: 500,
						color: "rgba(0, 0, 0, 0.87)",
					}}
				>
					{t("workers_add-skills-for-worker")}
				</Typography>
			</DialogTitle>
			<DialogContent>
				<Box
					sx={{
						//	paddingTop: "12px",
						paddingLeft: "21px",
						paddingRight: "21px",
						paddingBottom: "12px",
						//height: 540,
					}}
				>
					<AssignSkillForm closeDialog={onClose} onCombinedResult={onCombinedResult} />
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default AddWorkerSkillDialog;
